import { trpc } from '../../lib/trpc';
import { CheckInHistoryList } from '../checkIns/CheckInHistoryList';

interface PublicCheckInsProps {
  username: string;
}

/**
 * Another user's wineries visited, without dates. Absent (not a "hidden"
 * placeholder) unless they share their check-ins and have some.
 */
export const PublicCheckIns = ({ username }: PublicCheckInsProps) => {
  const { data } = trpc.checkIn.forUser.useQuery({ username });

  if (!data || data.venues.length === 0) {
    return null;
  }

  return (
    <section className="mt-8 w-full text-left">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Wineries visited</h2>
      <CheckInHistoryList items={data.venues} showDates={false} />
    </section>
  );
};
